module.exports = __webpack_public_path__ + "static/img/bg-overview@w.4bbf82b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket/bg-overview@w.jpg
// module id = lB0I
// module chunks = 0